import { Epic } from 'redux-observable';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { ofType, StateStatus } from '@alycecom/utils';
import { handleError, handlers } from '@alycecom/services';

import { checkCredentials, setIsWrongActivateEmail } from './credentials.actions';

export const checkCredentialsEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(checkCredentials.pending),
    switchMap(({ payload: { hashId, email, firstName, lastName, skipEmailVerification = true } }) =>
      apiService
        .post(`/api/recipient/code/${hashId}/activate-email`, {
          body: { email, first_name: firstName, last_name: lastName, skip_email_verification: skipEmailVerification },
        })
        .pipe(
          mergeMap((response: { success: boolean }) =>
            !response.success ? [checkCredentials.fulfilled(StateStatus.Rejected), setIsWrongActivateEmail(true)] : [],
          ),
          catchError(handleError(handlers.handleAnyError(checkCredentials.rejected))),
        ),
    ),
  );

export const credentialsEpics = [checkCredentialsEpic];
